
<script>
	import { onMount, tick } from "svelte";
    import { tooltip } from '$lib/app/tooltip.js';
    

    let {
        id,
        selected = $bindable(),
        variant = 'mobile',
        onclick
    } = $props();


    let mobile = (variant == 'mobile');
    let desktop = (variant == 'desktop');

    let imgSize = desktop ? 80 : 96;

    $inspect('map_style selected='+selected);

    //let helpEl = $state('test');
    
    let mapStyles = [
        { id: 'streets', name: 'Streets' },
        { id: 'openstreetmap', name: 'Openstreetmap' },
        { id: 'grayscale', name: 'Grayscale' },
        { id: 'bright', name: 'Bright' },
        { id: 'fiord-color', name: 'Fiord Color' },
        { id: 'terrain', name: 'Terrain' },
        { id: 'satellite-hybrid', name: 'Satellite Hybrid' },
        { id: 'charted-territory', name: 'Charted Territory' },
        { id: 'americana', name: 'Americana' },
    ];

    function handleHelp() {

    }

    function handleKeydown() {

    }

    function handleClick() {

    }

    function removeHTMLTags() {

    }

    function helpLineBySelected() {

    }
/*
    onMount(() => {  
        const scrollContent = document.getElementById('scroll-content');
        const scrollBar = document.getElementById('scroll-bar');
        const scrollBarInner = document.getElementById('scroll-bar-inner');

        // Match the width of the scrollable content
        function syncWidth() {
            scrollBarInner.style.width = scrollContent.scrollWidth + 'px';
        }

        syncWidth();
        window.addEventListener('resize', syncWidth);

        // Sync scrolling both ways
        scrollContent.addEventListener('scroll', () => {
            scrollBar.scrollLeft = scrollContent.scrollLeft;
        });

        scrollBar.addEventListener('scroll', () => {
            scrollContent.scrollLeft = scrollBar.scrollLeft;
        });
    });*/

      // scroll-into-view action
    function scrollIfHidden(node, flag) {
        if (flag) {
            node.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
        }
        return {
            update(newFlag) {
                if (newFlag) {
                    node.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
                }
            }
        };
    }

    export function scrollWithOffset(node, { active = false, container, offset = 32 } = {}) {
        function scroll() {
            if (!active || !container) return;

            const nodeRect = node.getBoundingClientRect();
            const contRect = container.getBoundingClientRect();

            const overLeft = nodeRect.left < contRect.left + offset;
            const overRight = nodeRect.right > contRect.right - offset;

            if (overLeft || overRight) {
                const scrollOffset = nodeRect.left - contRect.left - offset;
                container.scrollBy({ left: scrollOffset, behavior: 'smooth' });
            }
        }

        scroll(); // run on mount

        return {
                update({ active: newActive, container: newContainer, offset: newOffset = 32 }) {
                active = newActive;
                container = newContainer;
                offset = newOffset;
                scroll();
            }
        };
}


let containerEl = $state();

</script>

    <!--div role="menu" tabindex=0 onmouseleave={()=>handleHelp(selected)} onkeydown={handleKeydown}-->

        <!--div role="menuitem"
            class="mr-2 selectable"
            tabindex="-1"
            class:selected={selected===mapStyle.id}
            onclick={() => handleClick(mapStyle.id)}
            onmouseenter={() => handleHelp(mapStyle.id)}
        -->
<input type="hidden" name={id} bind:value={selected} />

<!--<div class="flex flex-row flex-wrap gap-2">
        {#each mapStyles as mapStyle, i}
            <div onclick={() => { selected = mapStyle.id; }}>
            <img alt={mapStyle.id} src={'/m/'+mapStyle.id+'.png'} width={size} height={size} 
                />
            </div>
        {/each}
</div>
-->

<div id="scroll-content" bind:this={containerEl} class="outer hide-scrollbar" class:mobile class:desktop>
    <div class="inner" class:mobile class:desktop>
        {#each mapStyles as mapStyle, i}
            <div 
                use:scrollWithOffset={{ active: selected === mapStyle.id, container: containerEl }}
                use:tooltip={mapStyle.name}
                onclick={(e) => {
                    selected = mapStyle.id;
                    tick().then(() => {
			            onclick(e);
		            });
                    //e.currentTarget.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
                }}
                class="item selectable" class:selected={selected==mapStyle.id}>
                    <img 
                        alt={mapStyle.id} 
                        src={'/m/' + mapStyle.id + '.png'} 
                        width={imgSize} 
                        height={imgSize}
                    />
            </div>
        {/each}
    </div>
</div>

<!-- Visible scrollbar below -->
 <!--
<div id="scroll-bar" class="scrollbar-proxy" style="max-width: 100%;">
    <div id="scroll-bar-inner" class="fake-scrollbar-content"></div>
</div>
-->

<!--p class="help" bind:this={helpEl}>
    {removeHTMLTags(helpLineBySelected(selected))}
</p-->



<style>
      /* Hide native scrollbar (works on most browsers) */
    .hide-scrollbar {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* IE/Edge */
    }

    .hide-scrollbar::-webkit-scrollbar {
        display: none; /* Chrome, Safari, etc. */
    }

    .outer.mobile {
        width: 100%;
        overflow-x: auto;
        /*background-color: lightblue;*/
      /*border: 1px solid red;  just to see it clearly */
    }

    .outer.desktop {
        /*background-color: lightgreen;*/
        max-width: 800px;
    }

    .inner.mobile  {
        display: flex;
        flex-wrap: nowrap;
        gap: 4px;
        width: max-content;
    }

    .inner.desktop {
        display: flex;
        max-width: 800px;
        flex-wrap: wrap;
        gap: 4px;
    }



    .item {
      flex-shrink: 0;
    }

    img {
      /*width: 96px;
      height: 96px;*/
      display: block;
      border-radius: 3px;
    }


    /*
    .avatars {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        width: max-content;
    }*/

    /* Show scrollbar in the proxy below */
    /*
    .scrollbar-proxy {
        overflow-x: auto;
        height: 12px;
    }

    .fake-scrollbar-content {
        height: 1px;
        pointer-events: none;
    }*/

    
    .selectable {
        /*padding: 0px;*/
        /*margin-top: 0.5rem;*/
        margin: 1px;
        border-radius: 4px;
        border-style: solid;
        border-width: 1px;
        /*border-color: rgba(0, 0, 0, 0);*/
        border-color: rgba(0, 0, 0, 0.12);
        cursor: pointer;
    }
    
    .selected {
        border-radius: 4px;
        /*border-color: #3847BA;*/
        border-color: rgb(17, 45, 255);
        /*box-shadow: rgba(56, 71, 186, 0.2) 0px 0px 0px 4px;  */
        transition: border-color .2s ease-out;
        transition: box-shadow .2s ease-out;
    }
    
    @media (prefers-color-scheme: dark) {
        .selected {
            border-color: rgb(117, 133, 255);
            box-shadow: 1px 1px 1px 0px  rgba(128,128,255,0.75);
        }
    }
</style>